<template>
  <v-footer dark padless>
    <v-card class="flex" flat tile style="background: #311B92">
      <v-card-title class="teal">
        <strong class="subheading text-h6">Get connected with me on social networks!</strong>
        <v-spacer></v-spacer>
        <v-btn dark icon color="mx-2" v-bind:href="linkedin" target="_blank">
            <v-icon>mdi-linkedin</v-icon>
        </v-btn>
        <v-btn dark icon color="mx-2" v-bind:href="github" target="_blank">
            <v-icon>mdi-github</v-icon>
        </v-btn>
        <v-btn dark icon color="mx-2" v-bind:href="linkedin" target="_blank">
            <v-icon>mdi-facebook</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="py-4 white--text text-center">
        Copy Rights &copy;{{ new Date().getFullYear() }} — <strong>RANDOMSCALA</strong>
      </v-card-text>
    </v-card>
  </v-footer>
</template>

<script>
  export default {
    data: () => ({
      linkedin: "https://www.linkedin.com/in/vikash-kumar-a40860176",
      github: "https://github.com/vikash8507",
    }),
  }
</script>